import React from 'react';
import { flex } from '@fabric-ui/theme';
import { abbreviateNumber } from '@fabric-ui/utils';
import { Box, SxProps, Theme } from '@mui/material';
import { AvTag } from '../AvTag';
import { AvTooltip } from '../AvTooltip';
import { useAvContext } from '../context/FabricProvider';
import { ingressProjIcons, uberProjIcons } from '../projIcons';

interface Props {
  projName: string;
  total: number;
  includeIngressProj?: boolean;
  includeProjName?: boolean;
  tooltipText?: boolean;
  sx?: SxProps<Theme>;
}

export const avProjIconTagContainerStyle = {
  pr: 0.5,
  gap: 1,
  fontSize: 12,
  borderRadius: 1.5,
  color: 'var(--color-content-base-secondary)',
  ...flex.itemsCenter,
  height: 20,
  fontWeight: '400',
  background: 'var(--color-surface-base-secondary)',
};
export const avProjTagInnerStyle = {
  borderRadius: 1.5,
  color: 'var(--color-content-base-primary)',
  background: 'var(--color-surface-base-tertiary)',
  ...flex.itemsCenter,
  padding: 0.15,
  fontWeight: 600,
  svg: { height: 14, width: 14 },
};
export const AvProjIconTag: React.FC<Props> = ({ projName, total, includeIngressProj, includeProjName, tooltipText = false, sx }) => {
  const {
    accountEntities: { aggProjs },
  } = useAvContext();
  const allProjIcon = { ...uberProjIcons, ...(includeIngressProj ? ingressProjIcons : {}) };
  const projIcon = allProjIcon[projName] ?? allProjIcon.default;
  const { projDisplayName } = aggProjs[projName];
  return (
    <AvTooltip title={projDisplayName} disabled={!tooltipText}>
      <AvTag
        key={projName}
        sx={{ border: 'none', padding: 0, ...sx }}
        text={
          <>
            <Box sx={avProjTagInnerStyle}>{projIcon.icon}</Box>
            {includeProjName && projDisplayName}
            <Box sx={{ pr: 0.25, ...(includeProjName && { fontWeight: 'bold' }) }}>{abbreviateNumber(total || 0)}</Box>
          </>
        }></AvTag>
    </AvTooltip>
  );
};
